import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationPolicyUpdateArgs, MutationPolicyUpdatev2Args, Policy } from "types/generated";

export const GET_POLICY = gql`
  query GetPolicyDetails($policyId: ID!) {
    authorizationScheme
    policy(id: $policyId) {
      id
      name
      body
      space
      labels
      updatedAt
      engineType
      sampleCount
    }
  }
`;

type UpdatePolicyData = Pick<Policy, "id" | "name" | "body" | "space">;
export const UPDATE_POLICY: TypedDocumentNode<
  { policyUpdate: UpdatePolicyData },
  MutationPolicyUpdateArgs
> = gql`
  mutation UpdateLoginPolicy(
    $id: ID!
    $name: String!
    $body: String!
    $labels: [String!]
    $space: ID
  ) {
    policyUpdate(id: $id, name: $name, body: $body, labels: $labels, space: $space) {
      id
      name
      body
      space
    }
  }
`;

/* eslint-disable @cspell/spellchecker */
export const UPDATE_POLICY_V2: TypedDocumentNode<
  { policyUpdatev2: UpdatePolicyData },
  MutationPolicyUpdatev2Args
> = gql`
  mutation UpdateLoginPolicyV2($id: ID!, $input: PolicyUpdateInput!) {
    policyUpdatev2(id: $id, input: $input) {
      id
      name
      body
      space
    }
  }
`;
/* eslint-enable @cspell/spellchecker */

export const DELETE_POLICY = gql`
  mutation DeleteLoginPolicy($id: ID!) {
    policyDelete(id: $id) {
      id
      name
    }
  }
`;
